
import AIChat from './AIChat.vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import MenuIcon from '@/components/Icons'

export default {
  components: {
    AIChat,
    MenuIcon,
  },
  setup() {
    const { t } = useI18n()
    const isOpen = ref(false)
    const openChat = () => {
      isOpen.value = true
    }
    const closeChat = () => {
      isOpen.value = false
    }

    return { isOpen, openChat, closeChat, t }
  },
}
